export function formatTimeDifference(makeLiveDate, previouslyMadeLiveDate = {}) {
  const currentDate = new Date();

  // Convert Firestore timestamps (seconds) to Date
  const liveDate = new Date(makeLiveDate?.seconds * 1000);
  const previousDate = previouslyMadeLiveDate?.seconds
    ? new Date(previouslyMadeLiveDate.seconds * 1000)
    : null;

  // If makeLiveDate is futuristic, fallback
  const effectiveDate = liveDate > currentDate && previousDate ? previousDate : liveDate;

  const diffInMilliseconds = currentDate - effectiveDate;
  const diffInSeconds = Math.floor(diffInMilliseconds / 1000);
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);

  if (diffInHours < 24) {
    return diffInHours > 0
      ? `${diffInHours}h ago`
      : `${Math.floor(diffInMinutes)}m ago`;
  } else {
    return `${diffInDays}d ago`;
  }
}



export function convertTimestamp_subAdmin(timestamp) {
  const dateObject = new Date(timestamp * 1000);
  const day = dateObject.getDate();
  const month = dateObject.toLocaleString("default", { month: "short" }); // Get abbreviated month name
  const year = dateObject.getFullYear();

  const result = {
    date: day,
    mAndY: `${month} ${year}`,
  };

  return result;
}

export function convertTimestamp_subAdminNew(timestamp) {
  if (!timestamp) return null;

  const d = new Date(timestamp.seconds * 1000);

  // Create new DATE ONLY (drop timezone shift issues)
  const nextDate = new Date(
    d.getUTCFullYear() + 1,
    d.getUTCMonth(),
    d.getUTCDate()
  );

  const day = nextDate.getUTCDate();
  const month = nextDate.toLocaleString("default", { month: "short" });
  const year = nextDate.getUTCFullYear();

  return {
    date: day+1,
    mAndY: `${month} ${year}`,
  };
}


export function getJobExpiresDate(makeLiveDate) {
  if (!makeLiveDate?.seconds) return null;

  const currentDate = new Date();
  const liveDate = new Date(makeLiveDate.seconds * 1000);

  const diffInMilliseconds = currentDate - liveDate;
  const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

  const expiresInDays = 30 - diffInDays;

  let text = "";
  if (expiresInDays > 1) {
    text = `${expiresInDays} days`;
  } else if (expiresInDays === 1) {
    text = "1 day";
  } else if (expiresInDays === 0) {
    text = "Expires Today";
  } else {
    text = "Expired";
  }

  return {
    text,
    daysLeft: expiresInDays > 0 ? expiresInDays : 0, // keep non-negative for styling logic
    rawDaysLeft: expiresInDays, // actual number (can be negative if expired)
  };
}


export function convertTimestampForMonthly(timestamp) {
  if (!timestamp) {
    return null;
  }

  // Convert from seconds to milliseconds
  const dateObject = new Date(timestamp.seconds * 1000);

  // Add exactly 30 days
  dateObject.setDate(dateObject.getDate() + 30);

  const day = dateObject.getDate();
  const month = dateObject.toLocaleString("default", { month: "short" });
  const year = dateObject.getFullYear();

  return {
    date: day,
    mAndY: `${month} ${year}`,
  };
}


export function convertValidUrl(inputUrl) {
  if (!inputUrl) return inputUrl;

  let url = inputUrl.trim();

  // Remove protocol if exists (http / https)
  url = url.replace(/^https?:\/\//, '');

  // Remove www if exists
  url = url.replace(/^www\./, '');

  // If no domain extension → add .com
  // checks for ".something" at the end
  if (!/\.[a-z]{2,}$/i.test(url)) {
    url = `${url}.com`;
  }

  // Add www + https
  url = `https://www.${url}`;

  return url;
}



export function convertValidAppllicationFlowURl(data) {
  if (!data?.startsWith("https://")) {
   return data = `https://${data}`;
  } else {
    return data
  }
}
